module.exports = __webpack_public_path__ + "img/郁金香-4.f55ca0ad.jpg";